module.exports = __webpack_public_path__ + "img/lnr-map-marker.8ac84332.svg";